import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import DropDownListViewModel from '@/ViewModels/Controls/DropDownListViewModel';

export default class EnumerationComboBoxViewModel extends ControlViewModel {

    /**
     * Die wählbaren Optionen
     */
    public dropDownList: DropDownListViewModel;

    /**
     * Das ViewModel für die EnumerationComboBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.dropDownList = this.paramOrDefault(params.dropDownList, null);
    }

    public resetValue(): void {
        this.dropDownList.value(null);
    }
}

ComponentManager.setViewModel('EnumerationComboBoxViewModel', EnumerationComboBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');